import { setToken, setUsuario } from "./auth";

/**
 * Painel embutido no ERP (iframe): o ERP abre "#<tela>&embed=1&t=<jwt>". Guarda o acesso do usuário,
 * marca o modo embutido e limpa o token do endereço. Chamado antes de montar o App.
 */
export function aplicarSsoDoHash(): void {
  const h = window.location.hash.replace(/^#/, "");
  if (!h.includes("&")) return;
  const [rota, ...params] = h.split("&");
  const p = new URLSearchParams(params.join("&"));
  const t = p.get("t");
  if (t) {
    try {
      const corpo = JSON.parse(atob(t.split(".")[1]!.replace(/-/g, "+").replace(/_/g, "/")));
      setToken(t);
      setUsuario({ codusu: Number(corpo.sub), apelid: String(corpo.apelid ?? ""), nomusu: String(corpo.nomusu ?? "") });
    } catch {
      /* token inválido: segue para o login */
    }
  }
  if (p.get("embed") === "1") sessionStorage.setItem("formsteel-embed", "1");
  // Tema do ERP (correção 26/10/2026): embutido, o Painel segue o tema do ERP e ignora o salvo no Painel.
  const tema = p.get("tema");
  if (tema === "claro" || tema === "escuro") sessionStorage.setItem("formsteel-embed-tema", tema === "escuro" ? "dark" : "light");
  window.history.replaceState(null, "", window.location.pathname + (rota ? "#" + rota : ""));
}

export const ehEmbutido = () => sessionStorage.getItem("formsteel-embed") === "1";

/** Tema vindo do ERP quando embutido (padrão claro); null fora do ERP. */
export const temaDoErp = (): "light" | "dark" | null =>
  ehEmbutido() ? (sessionStorage.getItem("formsteel-embed-tema") === "dark" ? "dark" : "light") : null;

/** Embutido: aplica o tema do ERP e passa a ouvir a troca (postMessage do ERP ao alternar o tema), sem recarregar. */
export function seguirTemaDoErp(): void {
  const t = temaDoErp();
  if (!t) return;
  document.documentElement.dataset.theme = t;
  window.addEventListener("message", (e) => {
    if (e.source !== window.parent) return;
    const d = e.data as { tipo?: string; tema?: string } | null;
    if (!d || d.tipo !== "fs-tema" || (d.tema !== "claro" && d.tema !== "escuro")) return;
    const novo = d.tema === "escuro" ? "dark" : "light";
    sessionStorage.setItem("formsteel-embed-tema", novo);
    document.documentElement.dataset.theme = novo;
    window.dispatchEvent(new CustomEvent("formsteel-tema", { detail: novo }));
  });
}
